import { useEffect, useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { useGetToken } from "@apis/users/useUsers"
import { garconClient } from "@apis/axiosClients"

export function useAuthToken() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0()
  const [isTokenConfigured, setIsTokenConfigured] = useState(false)

  const [auth0Token, setAuth0Token] = useState<string | undefined>(undefined)

  // Get Auth0 token
  useEffect(() => {
    if (isAuthenticated) {
      const fetchToken = async () => {
        try {
          const token = await getAccessTokenSilently()
          setAuth0Token(token)
        } catch (err) {
          console.error("Error getting Auth0 token", err)
        }
      }
      fetchToken()
    }
  }, [isAuthenticated, getAccessTokenSilently])

  // Get Garcon token using the Auth0 token
  const {
    data: tokenData,
    isSuccess,
    error: tokenError,
  } = useGetToken(auth0Token)

  // Set axios Authorization header with the Garcon token
  useEffect(() => {
    if (isSuccess && tokenData?.token) {
      garconClient.defaults.headers.common["Authorization"] =
        `Bearer ${tokenData.token}`
      setIsTokenConfigured(true)
    }
  }, [isSuccess, tokenData])

  return {
    isTokenConfigured,
    isAuthenticated,
    tokenError,
  }
}
